import { IShoppingBagData } from "../../types/ShoppingBag";
import { IPlaceData } from "../../types/Place";

import {
  AlertColor,
  Box,
  Button, CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { gerarLink } from "../../helpers/MapOrderToWhatsAppMessage";
import { ILoginData } from "../../types/Login";
import { IPaymentType } from "../../types/Payment";

type PromptSendOrderViaWhatsappDialogProps = {
  open: boolean
  handleClose: () => void
  showSnackbarMessage: (options: {message: string; severity: AlertColor;}) => void
  //shoppingBagQuery: UseQueryResult<IShoppingBagData>
  //placeInfo: IPlaceData | undefined
  //selectedPaymentType: IPaymentType | undefined

  // *** primeiro a situação: enquanto o pedido está sendo 'fechado/enviado' para o backend,
  // o cardápio mostra um dialog perguntando se o usuário deseja enviar o pedido via whatsapp
  // mas, os parametros acima (especialmente o shoppingBagQuery e selectedPaymentType) MUDAM durante a
  // exibição deste dialog, e ao final quando finalmente clica em 'sim, enviar para o whatsapp', essas informações
  // já estão inconsistentes (ex: shoppingBagQuery já foi atualizado para o novo pedido vazio, e selectedPaymentType também pode ter sido alterado)
  // *** a 'solução': por isso, eu criei este 'lastOrderState' que precisa ser SETADO ~antes~ de fechar o pedido, para garantir
  // que este dialog tenha as informações necessárias.
  lastOrderState: string
};

const unstrigify = (data:string) => {
  const parsed = JSON.parse(data)
  return {
    pI: parsed.placeInfo,
    sPT: parsed.selectedPaymentType,
    lI: parsed.loginInfo,
    sBQ: parsed.notNullShoppingData
  }
}

function PromptSendOrderViaWhatsapp({ open, handleClose,showSnackbarMessage, lastOrderState}: PromptSendOrderViaWhatsappDialogProps) {
  const [isSending, setIsSending] = useState<boolean>(false);

  //console.log('onWhatsappLink::', lastOrderState)

  let placeInfo : IPlaceData | undefined  = undefined;
  let selectedPaymentType : IPaymentType | undefined = undefined;
  let loginInfo : ILoginData | undefined = undefined;
  let shoppingBagQuery :IShoppingBagData | undefined = undefined;

  try {
    const {pI, sPT, lI, sBQ} = unstrigify(lastOrderState);

    //console.log('pI:', pI)
    //console.log('sPT:', sPT)
    //console.log('lI:', lI)
    //console.log('sBQ:', sBQ)

    placeInfo = pI
    selectedPaymentType = sPT
    loginInfo = lI
    shoppingBagQuery = sBQ
  }
  catch (error) {}

  if(!placeInfo) return (<></>)
  if(!selectedPaymentType) return (<></>)
  if(!placeInfo.redirect_to_whatsapp) return (<></>)
  if(!placeInfo.whatsapp_number) return (<></>)
  if(!loginInfo) return (<></>)
  if(!shoppingBagQuery) return (<></>)

//console.log("promptSendOrderViaWhatsapp 2");

  const sendViaWhatsApp = async () => {
    console.log("sendViaWhatsApp()");
    setIsSending(true)

    const placeInfoEhValido = placeInfo && placeInfo.redirect_to_whatsapp && placeInfo.whatsapp_number;

    if(!placeInfoEhValido){
      console.log("placeInfoEhValido = false")
      showSnackbarMessage({message: 'Informações do restaurante insuficientes para redirecionar ao WhatsApp.', severity: 'error'})
      setIsSending(false)
      return
    }

    if(!placeInfo || !selectedPaymentType || !loginInfo || !shoppingBagQuery) {
      console.log("!placeInfo || !selectedPaymentType || !loginInfo || !shoppingBagQuery")
      showSnackbarMessage({message: 'Informações insuficientes para gerar o pedido no WhatsApp.', severity: 'error'})
      setIsSending(false)
      return
    }

    //console.log('vai gerar link:')
    const link =
      gerarLink(placeInfo, selectedPaymentType, loginInfo, shoppingBagQuery)

    //console.log(link)

    setIsSending(false)
    window.open(link, '_blank')

    // e no final, fechar o dialog:
    handleClose()
  }

  return (
    <>
      <Dialog onClose={handleClose} open={open} sx={{
        zIndex: 9999,
      }}>
        <DialogTitle>Deseja enviar o pedido pelo WhatsApp?</DialogTitle>
        <DialogContent>
            <Box>
              <Typography>
                Ao enviar o pedido pelo WhatsApp, você pode entrar em contato com o Restaurante mais facilmente.
              </Typography>

              {(isSending
                && <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 2,
              }}
              >
                <CircularProgress size={30} sx={{padding:'5px'}}/><Typography display={"inline"}>Enviando pedido...</Typography>
              </Box>)}
            </Box>
            <Box display={"flex"} flexGrow={1}>
              <Button
                disabled={isSending}
                type="submit"
                color="primary"
                variant="contained"
                sx={{ color: "white", marginTop: "15px", width: "50%" }}
                onClick={ () => sendViaWhatsApp() }
              >
                Sim
              </Button>
              <Button
                disabled={isSending}
                color="primary"
                variant="outlined"
                sx={{ marginTop: "15px", width: "50%", marginLeft: 2 }}
                onClick={ () => handleClose() }
              >
                Não
              </Button>
            </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default PromptSendOrderViaWhatsapp;

